<template>
  <div>
    <v-container class="mt-1">
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout>
      <v-card class="mx-auto" style>
        <v-toolbar flat color="secondary accent-1" dark >
            <v-spacer></v-spacer>
            <v-toolbar-title>Quote Board</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-layout row wrap>
          <v-flex xs12 sm6 >
            <ctlQuoteBasicInfo :quoteData="quoteData" @reloadQuoteData="loadQuoteData"></ctlQuoteBasicInfo>
          </v-flex>
          <v-flex xs12 sm6>
            <ctlQuoteWorkflow :quoteData="quoteData" @reloadQuoteData="loadQuoteData"></ctlQuoteWorkflow>
            <ctlQuoteNotes :quoteData="quoteData" ></ctlQuoteNotes>
          </v-flex>
        </v-layout>

        <!-- 20210209, stop using this control after allow sales rep sending email
          <ctlQuoteItems :quoteData="quoteData" @onSaveItem="loadQuoteData"></ctlQuoteItems> -->
        <ctlQuoteItemsInternal 
          :quoteData="quoteData" 
          @reloadQuoteData="loadQuoteData"></ctlQuoteItemsInternal>

        <!-- <ctlQuoteDocs 
          v-show="userHasSalesSupportRole"
          :quoteData="quoteData" @quoteDocGenerated="loadQuoteData"
          @quoteEmailSent="loadQuoteData"
          @fileUploaded="loadQuoteData"
          ></ctlQuoteDocs> -->
        <ctlQuoteDocs 
          :quoteData="quoteData" @quoteDocGenerated="loadQuoteData"
          @quoteEmailSent="loadQuoteData"
          @fileUploaded="loadQuoteData"
          ></ctlQuoteDocs>

        <!-- <ctlQuoteActivities :quoteData="quoteData"></ctlQuoteActivities> -->
      </v-card>
    </v-container>
  </div>
</template>
<script>
import ctlQuoteItemsInternal from "@/components/ctlQuoteItemsInternal";
import ctlQuoteItems from "@/components/public/ctlQuoteItems";
import ctlQuoteBasicInfo from "@/components/public/ctlQuoteBasicInfo";
import ctlQuoteWorkflow from "@/components/ctlQuoteWorkflow";
import ctlQuoteNotes from "@/components/ctlQuoteNotes";
import ctlQuoteDocs from "@/components/ctlQuoteDocs";
// import ctlQuoteActivities from "@/components/ctlQuoteActivities";
// import jobTypeApi from '@/api/jobTypeApi'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ctlQuoteBasicInfo: ctlQuoteBasicInfo,
    ctlQuoteWorkflow: ctlQuoteWorkflow,
    ctlQuoteNotes: ctlQuoteNotes,
    // ctlQuoteActivities: ctlQuoteActivities,
    ctlQuoteItems: ctlQuoteItems,
    ctlQuoteDocs: ctlQuoteDocs,
    ctlQuoteItemsInternal,
  },
  data: () => ({
    quoteData: {
      basicInfo:{
        facilityShipMethod: {}
      },
      items: []
    },
  }),
  computed: {
    ...mapGetters("auth", [
        "loggedIn",
        "userHasSalesSupportRole"
      ]),
    id() {
      return this.$route.params.id;
    },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {},
  methods: {
      ...mapActions('pubQuoteEdit', [
          'saveSalesRepQuote',
          'populateNewQuote',
          'populateQuoteEditDataForSalesRep',
      ]),
      // ...mapActions('customerSearch', [
      //     'getFacilityDataById'
      // ]),
      async loadQuoteData() {
        this.quoteData = await this.populateQuoteEditDataForSalesRep(this.id)

      },
    onDismissed() {
    }
  },
  created: async function() {
    if(this.id) {
      await this.loadQuoteData()
    } else {
      this.quoteData = await this.populateNewQuote()
    }
  },
  mounted: function() {},
  destroyed: function() {
    this.onDismissed();
  }
};
</script>